var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"Button ui-button flex justify-center items-center",class:( _obj = {
    'Button--contained': _vm.contained === ''
  }, _obj[_vm.twostepclass] = _vm.status !== 0, _obj ),attrs:{"type":_vm.type,"title":_vm.status === 0 ? _vm.title : _vm.twosteptitle,"disabled":_vm.loading || _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[(_vm.loading)?_c('ui-loader',{attrs:{"variant":_vm.variant}}):_vm._e(),(_vm.status === 0)?_vm._t("default"):_vm._t("twostep")],2)}
var staticRenderFns = []

export { render, staticRenderFns }